import React from 'react';
import PropTypes from 'prop-types';
import './CaseCountDetail.scss';

import InformationBubble from 'Components/information-bubble/InformationBubble';

import OpenQueueShape from '../icons/OpenQueueShape/OpenQueueShape';
import { withRouter } from 'react-router-dom';

const CaseCountDetail = ({ region, user, customQueue, parentComponentName, dataColumns, caseCountData, workableCount, history }) => {
  const openQueue = () => {
    const customQueueId = customQueue.customQueueId;
    history.push(`/base-queue-landing?region=${region}&selectedBaseQueueItem=${encodeURIComponent(customQueue.queueLabel)}&customQueueId=${customQueueId}`);
  }
  if (parentComponentName == "CreatCustomQueLanding") {
    return (
      <div className="case-count-detail">
        <div className="case-count-detail-header-custom">
          <span className={'case-count-detail-list-item-header'}>
            {customQueue?.queueLabel}
          </span>
          <span className="case-count-detail-list-item-value">
            {customQueue?.queueDescription}
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <div className="case-count-detail">
        <div className="case-count-detail-header">
          <span className={'case-count-detail-list-item-header'}>
            {customQueue?.queueLabel}
          </span>
          <span className="case-count-detail-list-item-value">
            {customQueue?.queueDescription}
          </span>
        </div>

        <ul className="case-count-detail-list-new">
          {
            dataColumns.map((column) => {
              let value;
              if (column.displayType === 'STRING') {
                value = (
                  <div>
                    {caseCountData[`${column.columnKey}`] ? caseCountData[`${column.columnKey}`] : '--'}
                    <InformationBubble
                      id={column.columnKey}
                      info
                      tooltipContent={"Total unique cases created since the previous day"}
                    />
                  </div>
                );
              } else if (column.displayType === 'CRITICAL') {
                value = (
                  <div className="critical-cases">
                    {caseCountData[`${column.columnKey}`] ? caseCountData[`${column.columnKey}`] : '--'}
                    <InformationBubble
                      id={column.columnKey}
                      info
                      tooltipContent={"Total unique cases due within 5 days"}
                    />
                  </div>
                );
              } else if (column.displayType === 'WORKABLE') {
                value = (
                  <div>
                    { workableCount ? workableCount : '--'}
                    <InformationBubble
                      id={column.columnKey}
                      info
                      tooltipContent={"Total unique cases found"}
                    />
                  </div>
                );
              }
              return (
                <li
                  className="case-count-detail-list-item-new"
                  key={column.columnKey}
                >
                  <div className="case-count-detail-list-item-wrapper">
                    <span className="case-count-detail-list-item-label">
                      {column.title}
                    </span>
                  </div>
                  <div><span className={'case-count-detail-list-item-amount'}>
                    {value}
                  </span>
                  </div>
                </li>
              );
            })
          }
        </ul>

        <span>
          {user !== undefined && user.parsedPermissions.queue.viewCasesInQueue &&
            <button className="button-view" onClick={() => { openQueue() }}>
              <span className='icon-view'><OpenQueueShape /></span><span className="text-view">Open Queue</span>
            </button>
          }
        </span>
      </div>
    );
  }
};

CaseCountDetail.props = {
  dataColumns: PropTypes.array,
  caseCountData: PropTypes.object,
  parentComponentName: PropTypes.string,
  user: PropTypes.object,
};

CaseCountDetail.defaultProps = {
  dataColumns: [],
  caseCountData: {},
  parentComponentName: "",
};

export default withRouter(CaseCountDetail);
